import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	standalone: true,
	name: 'countValueTransportTerm',
})
export class CountValueTransportTerm implements PipeTransform {
	transform(data: any[], kind: string): string {
		const sumOfTransport = {
			slot: 0,
			reservation: 0,
			optionalSlot: 0,
			optionalReservation: 0,
		};
		data.forEach((x) => {
			sumOfTransport.reservation += x.sumOfTransport?.reservations[`${kind}ReservationCount`];
			sumOfTransport.slot += x.sumOfTransport?.slots[`${kind}SlotsCount`];
			sumOfTransport.optionalReservation += x.sumOfTransport?.reservations[`${kind}ReservationCountOptional`];
			sumOfTransport.optionalSlot += x.sumOfTransport?.slots[`${kind}SlotsCountOptional`];
		});
		return `${sumOfTransport?.slot} (${sumOfTransport?.reservation}) / ${sumOfTransport?.optionalSlot} / (${sumOfTransport?.optionalReservation})`;
	}
}
